// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__kHOcU","firstName":"logo_firstName__3xhBM","lastName":"logo_lastName__ydTlS"};